<template>
    <BaseContainer class="dnnCloud-menu-box" :loading="listLoading" :isHasPageFt="!listLoading">
        <template v-slot:hd>
          <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-form :inline="true" :model="souchs" @submit.native.prevent>
              <el-form-item>
                <el-input v-model="souchs.name" placeholder="企业名称" @keyup.enter.native="getTypeList(1)"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="medium" v-on:click="getTypeList(1)">查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="medium" @click="handleAdd" class="adds">新增</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </template>

        <template v-slot:main>
           <!--列表-->
          <el-table :data="typeList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" :height="maxTbHeight"
            style="width: 100%;" :header-cell-style="getRowClass" @sort-change="handleSortChange">
            <el-table-column type="index" :index="indexMethod" label="序号" width="100">
              <template slot-scope="scope">
                  <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="企业名称" min-width="240" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="code" label="企业ID" min-width="220" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="intime" label="创建时间" min-width="180" sortable="custom" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" min-width="220" style="text-algin:center">
              <template slot-scope="scope">
                 <span class="operate">
                    <el-tooltip effect="dark" content="编辑" placement="top" >
                      <span class="dnnfont iconEdit"   @click="handleEdit(scope.$index, scope.row)"></span>
                    </el-tooltip>

                    <el-tooltip effect="dark" content="删除" placement="top" v-if="!scope.row.delShow">
                        <span class="dnnfont icondelete"  @click="handleDel(scope.$index, scope.row)"></span>
                    </el-tooltip>
                 </span>

                <!-- <el-button type="primary" plain size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button type="danger" plain size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>

            <!--新增界面-->
          <el-dialog class="model-edit" title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="80px"  ref="addForm" :rules="addFormRules">
              <el-row>
                <el-col :span="22"> 
                  <el-form-item label="企业名称" prop="name">
                    <el-input v-model="addForm.name" auto-complete="off" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22"> 
                  <el-form-item label="企业ID" prop="code">
                    <el-input  v-model="addForm.code" @keyup.enter.native="addSubmit" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align:center">
              <el-button @click.native="addFormVisible = false">取消</el-button>
              <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
          </el-dialog>


          <!--编辑界面-->
          <el-dialog class="model-edit" title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" > 
            <el-form :model="editForm" label-width="80px"  ref="editForm" :rules="editFormRules">
              <el-row>
                <el-col :span="22"> 
                  <el-form-item label="企业名称" prop="name">
                    <el-input v-model="editForm.name" auto-complete="off" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="22"> 
                  <el-form-item label="企业ID" prop="code">
                    <el-input v-model="editForm.code" auto-complete="off" @keyup.enter.native="editSubmit" placeholder="请输入"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align:center">
              <el-button @click.native="editFormVisible = false">取消</el-button>
              <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
          </el-dialog>
        </template>

        <template v-slot:ft>
           <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-pagination 
              layout="sizes, prev, pager, next"
              :page-sizes="[10, 20, 30, 50,100]"
              :current-page="pageNumber" 
              @current-change="handleCurrentChange" 
              @size-change="handleSizeChange"
              :page-size="pageSize" 
              :total="total" 
              style="float:right;">
            </el-pagination>
          </el-col>
        </template>
      </BaseContainer>
</template>
<script>
import { API__code, API_Menu } from '../../../api/index.js'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  data(){
    return{
      token:'',
      checkCode:'',
      id:'',
      souchs:{},
      typeList:[],
      listLoading:false,
      pageNumber:1,
      total:0,
      pageSize: 20,

      addForm:{},
      addFormVisible:false,
      addLoading:false,
      addFormRules: {
        name: [
          { required: true, message: '请输入类型名称', trigger: 'blur' }
        ],
        
      },

      editFormVisible:false,
      editForm:{},
      editLoading:false,
      editFormRules: {
        name: [
          { required: true, message: '请输入类型名称', trigger: 'blur' }
        ],
      },
      orderType:'',
      orderStr:'',
    }
  },

  components: {
    BaseContainer
  },

  methods:{
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    editSubmit:function(){
      if(!this.editForm.name){
        this.$message.error('类型名称不可为空！');
        return;
      }
      if(!this.editForm.code && this.editForm.code != 0){
        this.$message.error('类型ID不可为空！');
        return;
      }
      let param ={
        id:this.editForm.id,
        token:this.token,
        checkCode:this.checkCode,
        mode:'',
        code:this.editForm.code,
        name:this.editForm.name,
      }
      this.editLoading = true;
      API_Menu.upTypeList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getTypeList();
        }else{
          this.$message.error(res.data.message);
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.editLoading = false;
        this.editFormVisible = false;
      }).catch(err =>{
        this.editLoading = false;
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm('确认删除该类型吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = { 
          id: row.id,
          token: this.token,
          checkCode: this.checkCode,
        };
        API_Menu.delTypeList(para)
        .then((res) => {
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getTypeList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch(() => {
          this.$message.error('服务器异常，请您稍后再试..');
        });
      });
    },

    addSubmit:function(){
      if(!this.addForm.name){
        this.$message.error('类型名称不可为空！');
        return;
      }
      if(!this.addForm.code && this.addForm.code != 0){
        this.$message.error('类型ID不可为空！');
        return;
      }
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        mode:'save',
        code:this.addForm.code,
        name:this.addForm.name,
      }
      this.addLoading = true;
      API_Menu.upTypeList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.getTypeList();
        }else{
          this.$message.error(res.data.message);
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.addLoading = false;
        this.addFormVisible = false;
      }).catch(err =>{
        this.addLoading = false;
        this.$message.error('服务器异常，请您稍后再试..');
      })
    },
    handleAdd:function(){
      this.addFormVisible = true;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex == 0) {
            return "background:#F5F7FA";
        } else {
            return "";
        }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*pageSize;
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getTypeList();
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getTypeList();
    },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "name"){
          this.orderStr = "namepx";
        }else if(val.prop == "code"){
          this.orderStr = "codepx";
        }else if(val.prop == "intime"){
          this.orderStr = "intimepx";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getTypeList();
    },
    getTypeList:function(val){
      if(val  == 1){
        this.pageNumber = 1;
      }
      let param ={
        token:this.token,
        checkCode:this.checkCode,
        listType:'page',
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        searchStr:this.souchs.name,
        orderType:this.orderType,
        orderStr:this.orderStr,
      }
      API_Menu.getTypeList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.total = res.data.data.totalPage;
          this.typeList = res.data.data.list;
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch(err =>{
        this.$message.error('服务器异常，请您稍后再试..');
      })
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
          var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
          for (var i = 0; i < arr.length; i++) {
              var arr2 = arr[i].split('='); //再次切割
              //判断查找相对应的值
              if (arr2[0] == 'dnnyptadmin_token') {
                  this.token = arr2[1]; //保存到保存数据的地方
              } else if (arr2[0] == 'dnnyptadmin_checkCode') {
                  this.checkCode = arr2[1];
              } else if (arr2[0] == 'dnnyptadmin_id') {
                  this.id = arr2[1];
              }
          }
      }
    },

  },
  created(){
    this.getCookie();
  },
  mounted(){
    this.getTypeList();
  },
}
</script>
<style lang="scss">
.dnnCloud-menu-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}

</style>




// WEBPACK FOOTER //
// Menu.vue?085c3659